import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Kazaplan360ViewerModule } from './kazaplan-360-viewer/kazaplan-360-viewer.module';
import { KazaplanViewerComponent } from './kazaplan-viewer/kazaplan-viewer.component';
import { KazaplanOptionsPopinComponent } from './kazaplan-options-popin/kazaplan-options-popin.component';
import { KazaplanService } from './kazaplan.service';
import { SharedModule } from '../../shared/shared.module';
import { UtilsModule } from '../../utils/utils.module';
import { ImgGalleryModule } from '../../shared/components/img-gallery/img-gallery.module';
import { Kazaplan360ViewerComponent } from './kazaplan-360-viewer/kazaplan-360-viewer.component';
import { KzModalModule } from '../../kz-ui/ui/modal/kz-modal.module';
import { KazaplanSharePopinComponent } from './kazaplan-share-popin/kazaplan-share-popin.component';
import { KzFormModule } from '../../kz-ui/ui/form/kz-form.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { KzIconsModule } from '../../kz-ui/ui/icon/kz-icons.module';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UtilsModule,
        ImgGalleryModule,
        Kazaplan360ViewerModule,
        KzModalModule,
        KzFormModule,
        NgSelectModule,
        KzIconsModule,
    ],
    declarations: [
        KazaplanViewerComponent,
        KazaplanOptionsPopinComponent,
        KazaplanSharePopinComponent,
    ],
    exports: [
        KazaplanViewerComponent,
        KazaplanOptionsPopinComponent,
        KazaplanSharePopinComponent,
        Kazaplan360ViewerComponent,
    ],
    providers: [
        KazaplanService,
    ]
})
export class KazaplanSharedModule { }
